angular.module('rjmNg.directives').directive "toggle", [
  "$timeout"
  ($timeout) ->
    restrict: 'E'
    template: "<input type='checkbox' ng-model='model' ng-disabled='disabled'></input>"
    scope:
      ngModel: "="
      convertToBools: "="
      ngDisabled: "="
    link: (scope, el, attrs) =>
      convertToBools = (potentialNumber) ->
        if potentialNumber is 0
          potentialNumber = false
        if potentialNumber is 1
          potentialNumber = true
        return potentialNumber


      scope.toggleButton = $(el)

      scope.toggleButton.toggleButtons(
        transitionspeed: 0.05
        label:
          enabled: "YES"
          disabled: "NO"
        style:
          enabled: "success"
        onChange: (el, status, e) =>
          scope.$parent.$eval(attrs.ngModel + " = " + status)
          $timeout( () =>
            scope.$parent.$apply()
          , 50)
      )

      if scope.ngDisabled
        scope.toggleButton.toggleButtons('toggleActivation')

      if scope.convertToBools? is true and scope.ngModel?
        scope.toggleButton.toggleButtons('setState', convertToBools(scope.ngModel))

      scope.getModel = () =>
        return scope.$parent.$eval attrs.ngModel

      scope.$watch('getModel()', () =>
        status = scope.$parent.$eval attrs.ngModel
        if scope.convertToBools? is true
          status = convertToBools(status)
        if status?
          scope.toggleButton.toggleButtons('setState', status)
      )
]
